"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathsKebabCase = void 0;
exports.PathsKebabCase = () => {
    return {
        PathItem(_path, { report, key }) {
            const segments = key.substr(1).split('/');
            if (!segments.every((segment) => /^{.+}$/.test(segment) || /^[a-z0-9-_.]+$/.test(segment))) {
                report({
                    message: `\`${key}\` is use kebab-case.`,
                    location: { reportOnKey: true },
                });
            }
        },
    };
};
